// 2026-06-20 (user request) — Identitas proyek: data INDUK sebagai satu sumber
// untuk nomor kontrak/PO, nilai kontrak, tanggal mulai, tanggal selesai, client,
// dan PIC. Read-only: tidak menimpa data historis; konflik dilaporkan sebagai
// peringatan untuk pemeriksaan manual.

export const IDENTITY_FIELDS = [
  { key: "contract_number", label: "Nomor Kontrak/PO" },
  { key: "contract_value", label: "Nilai Kontrak", numeric: true },
  { key: "start_date", label: "Tanggal Mulai", date: true },
  { key: "end_date", label: "Tanggal Selesai", date: true },
  { key: "client", label: "Client" },
  { key: "pic_name", label: "PIC" },
];

const norm = (v, { numeric, date } = {}) => {
  if (v === null || v === undefined || v === "") return "";
  if (numeric) return String(Number(v) || 0);
  if (date) return String(v).slice(0, 10);
  return String(v).trim();
};

/**
 * Resolve identitas kanonik sebuah proyek. Bila proyek adalah sub (VO/WO dengan
 * parent_project_id), sumber = dokumen induk; selain itu sumber = diri sendiri.
 * Return: { source, isInherited, fields, conflicts[] }.
 * conflicts: [{ key, label, childValue, parentValue }] — hanya bila NILAI ANAK
 * terisi DAN berbeda dari induk (anak kosong = mewarisi, bukan konflik).
 */
export function resolveIdentity(project, projects) {
  if (!project) return { source: null, isInherited: false, fields: {}, conflicts: [] };
  const byId = new Map((projects || []).map((p) => [p.id, p]));
  const parent = project.parent_project_id ? byId.get(project.parent_project_id) : null;
  const source = parent || project;
  const fields = {};
  const conflicts = [];
  for (const f of IDENTITY_FIELDS) {
    let parentVal = source[f.key];
    // Nomor kontrak induk: terima po_number sebagai alias bila contract_number kosong.
    if (f.key === "contract_number" && !norm(parentVal)) parentVal = source.po_number;
    fields[f.key] = parentVal ?? null;
    if (parent) {
      let childVal = project[f.key];
      if (f.key === "contract_number" && !norm(childVal)) childVal = project.po_number;
      const c = norm(childVal, f);
      const p = norm(parentVal, f);
      if (c && p && c !== p) {
        conflicts.push({ key: f.key, label: f.label, childValue: childVal, parentValue: parentVal });
      }
    }
  }
  return { source, isInherited: !!parent, fields, conflicts };
}
